import { SET_STATE, RESET, PARTICIPANT_JOINED, PARTICIPANT_LEFT, PARTICIPANT_USER_ID_KNOWN, SET_FILM_STRIP_DISPLAY, SET_SCREEN_SHARE, SET_IGNORE_DEVICE_WARNING, SHOW_RECORDING_INSTRUCTIONS, CLOSE_RECORDING_INSTRUCTIONS, VIDEO_CONFERENCE_JOINED, DOMINANT_SPEAKER_CHANGED  } from './actionTypes'
import {  END_POINT as WORKOUT_TOGETHER_END_POINT } from '../workoutTogether/actionTypes'
import {  END_POINT as GYM_END_POINT } from '../workoutTogether/actionTypes'
import { receiveEndPointMessage as receiveEndPointMessageWorkoutTogether } from '../workoutTogether/actions'
import { receiveEndPointMessage as receiveEndPointMessageGym } from '../workoutTogether/actions'

import { } from '../gym/actions'


export function setState ( newState ) {
  
  return { type : SET_STATE, newState }
}


export function reset () {

  return (dispatch, getState) => {

    const state = getState()

    if ( state.otuVision.onCall ) {
      dispatch( hangup())
    }

    dispatch( { type : RESET } )
  }
}

export function setVisible ( visible ) {
  return { 
    type : RESET
    }  

  //return { type : SET_STATE, newState : { visible } } 
}

// TODO Add joinMeetingAction

export function setOnCall ( onCall ) {

  return (dispatch, getState) => {

    const state = getState()

    if ( state.otuVision.onCall && !onCall ) {

      //jQuery("#" + otuApp.appState.menuBarTemplate).fadeIn()

      dispatch( setDockToSide( false ) ).then ( () =>
        dispatch( { 
          type : RESET
          }  
        )
      )




    } else {
      //jQuery("#" + otuApp.appState.menuBarTemplate).fadeOut()

      dispatch( { type : SET_STATE, newState : { onCall,  visible : true } } )

    }
  }

}

export function setDockToSide ( dockToSide ) {
    

  return (dispatch, getState) => {

    const state = getState()

    if ( dockToSide ) {
        document.body.classList.add('otuVisionDockedRight');
    } else {
        document.body.classList.remove('otuVisionDockedRight');
    }

    if ( state.otuVision.filmStripVisible && dockToSide) {
      dispatch(toggleFilmStrip())
    }

    if ( !state.otuVision.filmStripVisible && !dockToSide) {
      dispatch(toggleFilmStrip())
    }

    dispatch( {
      type : SET_STATE, 
      newState : { 
        dockToSide
      } 
    });

    dispatch( toggleMoreActions( false ) )


		backgroundMap.invalidateSize(false);
	  backgroundMap.setZoom(0,{animate:false});
	  backgroundMap.setZoom(1,{animate:false});

    return Promise.resolve();
    
  }
}

export function hangup () {

  return (dispatch, getState) => {
    dispatch( setOnCall(false) )   
  }
}

export function tryMuteAll () {

  return (dispatch, getState) => {
    const state = getState();

    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('muteEveryone')
    } catch ( e ) {
      console.error( 'otuVision - muteAll failed', e )
    }

    dispatch( toggleMoreActions( false ) )

  }

}

export function chat() {

  return (dispatch, getState) => {
    const state = getState();

    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('toggleChat')
    } catch ( e ) {
      console.error( 'otuVision - toggleChat failed', e )
    }

    dispatch( toggleMoreActions( false ) )

  }

}

export function playCatchAWave () {

  return (dispatch, getState) => {
    const state = getState();

    otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.newGame',{
      callback : function () {
        if (!state.otuVision.screenShared)
          dispatch( setDockToSide(true) )
      }
    } )

    dispatch( toggleMoreActions( false ) )

  }

}

export function setShareScreen ( screenShareState ) {
  return (dispatch, getState) => {
    const state=getState()

    if (state.otuVision.dockToSide && screenShareState.on ) {
      dispatch( setDockToSide(false) )
    }

    // This code should not be strictly necesarry I wonder why it is here
    /*
    if ( !screenShareState.on && state.otuVision.screenShared )
    setTimeout(() => {
      if ( state.otuVision.videoMuted && !state.otuVision.screenShared ) {
        dispatch( toggleVideo() )
      }
    }, 1000);
    */
   
    dispatch({
      type : SET_SCREEN_SHARE,
      screenShareState
    })

  }
}

export function setIgnoreDeviceSupportWarning ( ignoreDeviceSupportWarning ) {
  return (dispatch, getState) => {
    dispatch({
      type : SET_IGNORE_DEVICE_WARNING,
      ignoreDeviceSupportWarning
    })

  }
}

export function toggleShareScreen () {

  return (dispatch, getState) => {
    const state = getState();

    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('toggleShareScreen')
    } catch ( e ) {
      console.error( 'otuVision - toggleShareScreen failed', e )
    }

    dispatch( toggleMoreActions( false ) )

  }

}

export function toggleFilmStrip () {

  return (dispatch, getState) => {
    const state = getState();

    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('toggleFilmStrip')
    } catch ( e ) {
      console.error( 'otuVision - toggleFilmStrip failed', e )
    }

  }

}

export function toggleMute () {

  return (dispatch, getState) => {
    const state = getState();

    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('toggleAudio')
    } catch ( e ) {
      console.error( 'otuVision - toggleMute failed', e )
    }

    dispatch( toggleMoreActions( false ) )

  }

}

export function toggleVideo () {

  return (dispatch, getState) => {
    const state = getState();

    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('toggleVideo')
    } catch ( e ) {
      console.error( 'otuVision - toggleVideo failed', e )
    }

  }

}

export function filmstripDisplayChanged( visible ) {
  return { type : SET_FILM_STRIP_DISPLAY, visible } 
}



export function toggleMoreActions ( moreActionsVisible ) {
  return { type : SET_STATE, newState : { moreActionsVisible } }
}

export function bindMeetApi ( meetApi ) {
  return { type :SET_STATE, newState : { meetApi } }

}

export function showAlreadyOnCall( ) {

  otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=otuVision.showAlreadyOnCall');
}

export function showAlreadyInGym( ) {

  otuApp.triggerAjaxGet( otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=otuVision.showAlreadyInGym');
}

export function showMeetingRooms( options = { } ) {
  console.log('otuVision - showMeetingRooms')
  return (dispatch, getState) => {

    const state = getState()

    if ( state.otuVision.loading ) return 

    if ( state.otuVision.visible ) {
      dispatch( showAlreadyOnCall );
      return;
    } 

    dispatch ( { 
        type : RESET
      }
    ) 

    dispatch ( { 
        type : SET_STATE, 
        newState : { 
            loading : true,
          } 
      } 
    )

    const url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=otuVision.showMeetingRooms'

    otuApp.triggerAjaxGet( url , {
        callback : () => {
          /*
          dispatch ( { 
              type : SET_STATE, 
              newState : { 
                  loading : false,
                  visible : true,
                } 
            } 
          )
          */
        } 
      } 
    )
  }
}


export function showManageGym( options = {} ) {
  
  return (dispatch, getState) => {

        dispatch( toggleMoreActions( false ) )

        dispatch( { 
            type : SET_STATE, 
            newState : { 
              visible : true,
              showManageGym : true,
            } 
          } 
        )
  }
}

export function closeManageGym() {
  
  return (dispatch, getState) => {
  
    dispatch( { 
        type : SET_STATE, 
        newState : { 
          showManageGym: false
        } 
      } 
    )
  
  }

}


export function showGymRoom( options = { } ) {
  console.log('otuVision - showMeetingRooms')
  return (dispatch, getState) => {

    const state = getState()

    if ( state.otuVision.loading ) return 

    if ( state.otuVision.visible ) {
      if ( options.gym.gymId == state.gym.gymId  ) {
        // we are trying to open the current gym so lets open the gym members
        dispatch( showManageGym() )
        return

      } else {
        dispatch( showAlreadyInGym )
        return
      }
      
    } 

    dispatch ( { 
        type : RESET
      }
    ) 

    dispatch ( { 
        type : SET_STATE, 
        newState : { 
            loading : true
          } 
      } 
    )

    const url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=gym.showGymRoom'

    otuApp.triggerAjaxPost( url , {
      gymId : options.gym.gymId 
    }, {
        callback : () => {
          /*
          dispatch ( { 
              type : SET_STATE, 
              newState : { 
                  visible : true,
                  loading : false
                } 
            } 
          )
          */
        } 
      } 
    )
  }
}

export function getUserId( participant, retry = 0 ) {

  return (dispatch, getState) => {

  setTimeout(function(){
    const state = getState()
    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    const avatarURL = meetApi.getAvatarURL(participant.id);
    console.log(avatarURL);

    if ( avatarURL ) {
      try {
        const url = new URL(avatarURL);
        participant.userId = url.searchParams.get("userId");
        participant.avatar = [url.protocol, '//', url.host, url.pathname].join('')

        dispatch({
          type : PARTICIPANT_USER_ID_KNOWN,
          participant
        })
      } catch(e) {
        console.error(e)
      }
      
    } else {
      // try again
      if ( retry<5 ) {
        dispatch( getUserId( participant, (++retry) ))
      }
    }
    },1000);

  }

}

export function videoConferenceJoined ( videoConferenceInfo ) {
  return (dispatch, getState) => {

    dispatch({
      type : VIDEO_CONFERENCE_JOINED,
      videoConferenceInfo
    })

  }
}


export function dominantSpeakChanged ( dominantSpeaker ) {
  return (dispatch, getState) => {
    dispatch({
      type : DOMINANT_SPEAKER_CHANGED,
      dominantSpeaker
    })

    const state = getState()
    const meetApi = state.otuVision.meetApi


    if ( state.otuVision.videoConferenceInfo.id !== dominantSpeaker.id ) {
      // When the dominant speaker is not ourself we set him in view
      meetApi.setLargeVideoParticipant( dominantSpeaker.id );
    }

  }
}

export function participantJoined ( participant ) {
  return (dispatch, getState) => {
    
    participant.avatar = null
    participant.userId = null

    dispatch({
      type : PARTICIPANT_JOINED,
      participant
    })

    dispatch(getUserId( participant ))

  }
}

export function participantLeft ( participant ) {
  return {
    type : PARTICIPANT_LEFT,
    participant
  }
}

export function sendEndPointMessage( message, participants = [] ) {

  return (dispatch, getState) => {

    console.log( 'otuVision - SendEndPointMessage', message, participants)

    const state = getState()
    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    const messageEncoded = JSON.stringify( message )
    
    participants.forEach( function ( participant ) {
      console.log( 'otuVision - Sending Message', messageEncoded, participant )
      meetApi.executeCommand('sendEndpointTextMessage', participant.id, messageEncoded )
    } ) 

  }
}

export function receiveEndPointMessage ( message ) {

  return ( dispatch, getState ) => {

    console.log( 'otuVision - ReceiveEndPointMessage', message )

    switch ( message.data.eventData.name ) {
      case 'endpoint-text-message' :
        try { 
          const payLoad = JSON.parse ( message.data.eventData.text )
          message.data.payload = payLoad
        } catch (e) { 
          console.error(e)
          return
        }       
        break
      default:
        throw 'otuVision - No such Data Channel know..'
    }

    switch ( message.data.payload.target ) {
      case WORKOUT_TOGETHER_END_POINT:
        dispatch ( receiveEndPointMessageWorkoutTogether ( message.data) )
        break

      case GYM_END_POINT:
        dispatch ( receiveEndPointMessageGym ( message.data) )
        break

      default:
        throw 'otuVision - No EndPoint Target specified...'
    }

  }
}

export function startRecording () {

  return (dispatch, getState) => {

    const state = getState()
    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('startRecording', {
        mode: 'file',
        //dropboxToken: string, //dropbox oauth2 token.
        //shouldShare: boolean, //whether the recording should be shared with the participants or not. Only applies to certain jitsi meet deploys.
        //youtubeStreamKey: string, //the youtube stream key.
        //youtubeBroadcastID: string //the youtube broacast ID.
    });    } catch ( e ) {
      console.error( 'otuVision - startRecording failed', e )
    }

  }

}

export function stopRecording () {

  return (dispatch, getState) => {

    const state = getState()
    const meetApi = state.otuVision.meetApi

    if ( meetApi === null ) return

    try {
      meetApi.executeCommand('stopRecording', {
        mode: 'file',
    });    } catch ( e ) {
      console.error( 'otuVision - stopRecording failed', e )
    }

  }

}

export function showRecordingInstructions() {
  return {
    type : SHOW_RECORDING_INSTRUCTIONS
  }
}

export function closeRecordingInstructions() {
  return {
    type : CLOSE_RECORDING_INSTRUCTIONS
  }
}







